module.exports = __webpack_public_path__ + "static/media/d6.af1da772.png";